import makeStyles from '@mui/styles/makeStyles';
import { stepContainer } from '../ui/styles';

// Figma "Billing migration" box (73:1880): same light-blue info-box pattern
// as the rest of the flow - Secondary/100, 8px radius, 12px gap, H6 title,
// caption body with an explicit line break.
export const createClasses = makeStyles(theme => ({
  container: stepContainer(theme),
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderRadius: '8px',
    backgroundColor: theme.palette.secondary[100]
  },
  infoTitle: {
    fontWeight: 500,
    lineHeight: '19px',
    color: theme.palette.text.primary
  },
  infoBody: {
    fontSize: '12px',
    lineHeight: '15px',
    whiteSpace: 'pre-line',
    color: theme.palette.text.secondary
  }
}));
